import { Breadcrumb, Table, Menu, Image, Row, Col, Button, Modal, Upload, message, ConfigProvider, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import Label_language from '../language';
const { confirm } = Modal;
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children
const AdminCourseStudentAttendance = () => {
    return (
        <>
            <Row gutter={[8, 8]} justify={'end'}>
                <Col>
                    <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} icon={<PlusOutlined />}>新增補課</Button>
                </Col>
                <Col span={24}>
                    <Table columns={[
                        {
                            title: '學號',
                            dataIndex: 'week',
                            fixed: 'left',
                        },
                        {
                            title: '補課學生',
                            dataIndex: 'content',
                            fixed: 'left',
                        }, {
                            title: '打卡時繳',
                            dataIndex: 'content'
                        }, {
                            title: '出席',
                            dataIndex: 'content',
                            render: (text, record, index) => (
                                <>
                                    {record.address == '出席' ?
                                        <>
                                            <Row justify={'center'}>
                                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                                            </Row>
                                        </> : null
                                    }
                                </>),
                        }, {
                            title: '遲到',
                            dataIndex: 'content'
                        }, {
                            title: '請假',
                            dataIndex: 'content'
                        }, {
                            title: '缺席',
                            dataIndex: 'content'
                        }, {
                            title: '出席率',
                            dataIndex: 'content'
                        }, {
                            title: (<>歷史狀況<br />出席/遲到/請假</>),
                            dataIndex: 'content'
                        }]}></Table>
                </Col>
            </Row>
        </>
    )
}
export default AdminCourseStudentAttendance;